export type OrgTrainingScheduleId = string;

export enum OrgTrainingScheduleStatus {
  draft = "draft",
  published = "published",
  archived = "archived"
}

export interface OrgTrainingScheduleTimeSlot {
  startTime: string; // "HH:mm" e.g. "16:30"
  endTime: string; // "HH:mm" e.g. "17:45"
}

export interface OrgTrainingScheduleAssignment {
  teamId: string;
  squad?: "a" | "b" | "c";
}

export interface OrgTrainingScheduleFieldDay {
  timeSlots: {
    [slotKey: string]: {
      slot: OrgTrainingScheduleTimeSlot;
      assignments: OrgTrainingScheduleAssignment[];
    };
  };
}

export interface OrgTrainingSchedule {
  id: OrgTrainingScheduleId;
  orgId: string;
  name: string;
  startDateMS: number;
  endDateMS: number;
  status: OrgTrainingScheduleStatus;
  includedOrgFieldIds: string[];

  // Template: fieldId -> dayOfWeek (0=Sun..6=Sat) -> slots with assignments
  fieldDaySlots: {
    [orgFieldId: string]: {
      [dayOfWeek: number]: OrgTrainingScheduleFieldDay;
    };
  };

  // Per-date overrides (cancel a day, swap teams for one week, etc.)
  // DEPRECATED inline storage — new overrides are written to the OrgTrainingScheduleOverride collection.
  // Kept for backward compatibility with existing schedules. Reads merge both sources (subcollection wins).
  dateOverrides?: {
    [dateString: string]: {
      // "YYYY-MM-DD"
      canceled?: boolean;
      closedFieldIds?: string[]; // Fields closed on this date (all slots on these fields treated as canceled)
      fieldOverrides?: {
        [orgFieldId: string]: {
          [slotKey: string]: {
            canceled?: boolean;
            assignments?: OrgTrainingScheduleAssignment[];
            startTime?: string; // "HH:mm" — for one-off override slots not in template
            endTime?: string; // "HH:mm" — for one-off override slots not in template
          };
        };
      };
    };
  };

  lastPublishedAtMS?: number;

  // Set when publish or sync starts; cleared on success/failure. Used to reject concurrent operations.
  // Stale if > 5 minutes old (operation likely crashed).
  syncInProgressAtMS?: number;

  // Last failure from publish/sync, if any. Cleared on successful operation.
  lastSyncErrorAtMS?: number;
  lastSyncErrorMessage?: string;

  createdAtMS: number;
  updatedAtMS: number;
}
